<template>
  <component :is="tag" @click.native="handleClick" v-bind="$attrs" tag="li">
    <a class="nav-link">
      <slot>
        <i v-if="link.icon" :class="link.icon"></i>
        <p>{{ link.name }}</p>
        <i
          v-if="link.hasSubmenu"
          class="nc-icon"
          :class="link.isSubmenuOpen ? 'nc-minimal-up' : 'nc-minimal-down'"
        ></i>
      </slot>
    </a>
    <!-- Agregar el submenú aquí -->
    <ul v-if="link.hasSubmenu" class="submenu">
      <li v-for="(sublink, subIndex) in link.submenu" :key="subIndex">
        <router-link :to="sublink.to">
          {{ sublink.label }}
        </router-link>
      </li>
    </ul>
  </component>
</template>
<script>
export default {
  inheritAttrs: false,
  inject: {
    autoClose: {
      default: true,
    },
  },
  props: {
    link: {
      type: Object,
      default: () => {
        return {
          name: '',
          path: '',
          icon: '',
          hasSubmenu: false, // Indicador de si el enlace tiene un submenú
          isSubmenuOpen: false, // Indicador de si el submenú está abierto
        };
      },
    },
    tag: {
      type: String,
      default: 'router-link',
    },
  },
  methods: {
    handleClick() {
      if (this.link.hasSubmenu) {
        // Si el enlace tiene un submenú, alternamos su estado de apertura/cierre
        this.link.isSubmenuOpen = !this.link.isSubmenuOpen;
      } else {
        if (this.autoClose && this.$sidebar && this.$sidebar.showSidebar === true) {
          this.$sidebar.displaySidebar(false);
        }
      }
    },
  },
};
</script>
<style>
</style>
